import myAPI from '../resources'
import config from '../../config'
var miccServerBase = `${config.miccServerBase}`;
var miccSdkBase = `${miccServerBase}/miccsdk/api/v1`;
var miccAuthBase = `${miccServerBase}/authorizationserver`;
var bearerToken = '';

export default {
    login: (creds) => {
        var data = `grant_type=password&username=${creds.username}&password=${creds.password}`;
        return myAPI.post(`${miccAuthBase}/token`, data, {
            headers: {
                'Content-Type': `application/x-www-form-urlencoded`
            }
        }).then(resp =>{
            return resp;
        }).catch((err) => {return { data: err.message }})
    },
    checkEmployeeConversations: (creds) => {
        return myAPI.get(`${miccSdkBase}/employees/me/conversations`, {
            headers: {
                'Authorization': `Bearer ${creds}`
            }
        }).then(resp => {
            return resp.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/clients/mitelService.js